import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component } from '@angular/core'

@Component({
    selector: 'ca-edit-docx-terms-dialog',
    templateUrl: './edit-docx-terms-dialog.html'
})
export class EditDocxTermsDialogComponent extends CaDialogComponent<void, boolean> {

    onlineEditTermsAgreement = false

    constructor() {
        super()
    }

    closeModal(result: boolean): void {
        super.result = result
        super.close()
    }

    toggleOnlineEditTermsAgreement(): void {
        this.onlineEditTermsAgreement = !this.onlineEditTermsAgreement
    }

    passAgreement(): void {
        if (!this.onlineEditTermsAgreement) {
            return
        }
        this.closeModal(this.onlineEditTermsAgreement)
    }
}